import * as api from '../../../clients/einlasskontrolle';

import {Action} from '@ngrx/store';

export const POST_CREATE_SAMPLES = '[EinlasskontrolleModul] PostCreateSamples laden';
export const POST_CREATE_SAMPLES_AUSFUEHREN = '[EinlasskontrolleModul] PostCreateSamples ausführen';
export const POST_CREATE_SAMPLES_ERFOLGREICH = '[EinlasskontrolleModul] PostCreateSamples laden erfolgreich';
export const POST_CREATE_SAMPLES_FEHLER = '[EinlasskontrolleModul] PostCreateSamples Ladefehler';
export const POST_CREATE_SAMPLES_NICHT_AUSGEFUEHRT = '[EinlasskontrolleModul] PostCreateSamples nicht ausgeführt (evtl. Offline)';


export class PostCreateSamplesAction implements Action {
    readonly type = POST_CREATE_SAMPLES;
        constructor(public optPayload: any = null) {}
    }
export class PostCreateSamplesAusfuehrenAction implements Action {
    readonly type = POST_CREATE_SAMPLES_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class PostCreateSamplesErfolgreichAction implements Action {
    readonly type = POST_CREATE_SAMPLES_ERFOLGREICH;
        constructor(public payload: api.BoolResponse, public optPayload: any = null) {}
    }
export class PostCreateSamplesFehlerAction implements Action {
    readonly type = POST_CREATE_SAMPLES_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class PostCreateSamplesNichtAusgefuehrtAction implements Action {
    readonly type = POST_CREATE_SAMPLES_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type EinlasskontrolleCommandCreateSamplesActions =
    PostCreateSamplesAction
    | PostCreateSamplesAusfuehrenAction
    | PostCreateSamplesErfolgreichAction
    | PostCreateSamplesFehlerAction
    | PostCreateSamplesNichtAusgefuehrtAction
    ;
